import { createClient } from '@supabase/supabase-js';
import { Database } from './types';

// 🔒 SEGURANÇA: Credenciais devem vir APENAS de variáveis de ambiente
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Validação obrigatória - NÃO permite fallback para evitar vazamento
if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    '🔒 ERRO DE SEGURANÇA: As variáveis VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY são obrigatórias.\n' +
    'Configure-as em um arquivo .env.local na raiz do projeto:\n\n' +
    'VITE_SUPABASE_URL=sua_url_aqui\n' +
    'VITE_SUPABASE_ANON_KEY=sua_chave_aqui\n'
  );
}

// Criar cliente como singleton
let supabaseInstance = null;

export const getSupabase = () => {
  if (!supabaseInstance) {
    supabaseInstance = createClient<Database>(supabaseUrl, supabaseAnonKey);
  }
  return supabaseInstance;
};

// Para compatibilidade com código existente
export const supabase = getSupabase();
